import { ComponentType } from "react";
import { useConfig } from "@dit/ui-configurations/configurations";
import { GlobalConfigDefinition } from "../globalConfig";

/** @deprecated Use `useConfig() hooh` instead */
export interface WithConfig {
    config: GlobalConfigDefinition;
}

/** @deprecated Use `useConfig() hook` instead */
export const withConfiguration = <P extends WithConfig>(Component: ComponentType<P>) => {
    const WrappedComponent = (props: Omit<P, keyof WithConfig>) => {
        const config = useConfig<GlobalConfigDefinition, GlobalConfigDefinition>(c => c);

        return <Component {...(props as P)} config={config} />;
    };
    return WrappedComponent;
};

export const splitIoConfig = "configs/splitio.json";
export const globalConfigUrl = "configs/config.json";
